import { createStyles } from 'antd-style';
export var useStyles = createStyles({
  container: {
    '& > .ant-pro-card-body': {
      '& > .ant-pro-card-body-decorator': {
        fontSize: 20,
        position: 'absolute',
        right: 12,
        top: 12,
        transition: 'all 0.3s ease-in-out'
      },
      '&:hover': {
        '& > .ant-pro-card-body-decorator': {
          fontSize: '24px !important'
        },
        boxShadow: 'rgb(0, 0, 0, 0.75) 0 0 24px'
      },
      width: '100%',
      height: '100%',
      // background: 'rgb(17, 4, 134)',
      borderRadius: 12,
      boxShadow: 'rgb(0, 0, 0, 0.5) 0 0 24px',
      display: 'flex',
      color: 'white',
      justifyContent: 'center',
      flexDirection: 'column',
      background: 'linear-gradient(to right, rgb(20, 30, 48), rgb(36, 59, 85))',
      cursor: 'pointer',
      transition: 'all 0.3s ease-in-out',
      overflow: 'hidden'
    },
    borderRadius: 12
  }
});